export default __webpack_public_path__ + "static/summer_containers44-a26391b3f61cee2cdfc8103d0ba04a0b.webp";